// src/js/helpers/gwpCodeUtils.js
async function getCart() {
  try {
    var response = await fetch(window.Shopify.routes.root + "cart.js", {
      method: "GET"
    });
    if (response.status === 200) {
      const resJson = await response.json();
      return resJson;
    } else {
      throw new Error(response.message);
    }
  } catch (err) {
    console.error(err);
  }
}
async function getCartData() {
  try {
    let cart = await getCart();
    return {
      cartRaw: cart,
      cartItemVariantIds: cart?.items.map(
        (item) => item.variant_id?.toString()
      ),
      cartItemsWithGwpProps: cart?.items.map((item) => ({
        variant_id: item.variant_id?.toString(),
        properties: {
          _gwp_code_value: item.properties?._gwp_code_value,
          _gwp_code_hash: item.properties?._gwp_code_hash
        }
      })),
      // return value of user's shopping cart as an integer, in cents;
      cartTotalPrice: cart?.total_price ?? 0
    };
  } catch (err) {
    console.error(err);
  }
}
function getLocalStorage(key) {
  let stringVal = localStorage.getItem(key);
  if (!stringVal) {
    return void 0;
  }
  let parsedVal = JSON.parse(stringVal);
  return parsedVal;
}
function testCartMeetsProductPurchaseRequirement(requiredProductPurchases, cartItemVariantIds) {
  let missingProducts = [];
  for (let product of requiredProductPurchases) {
    if (!cartItemVariantIds.includes(product.variantId)) {
      missingProducts.push(product);
    }
  }
  return {
    doesMeetProductPurchaseRequirement: missingProducts.length === 0,
    productsNeededToMeetRequirement: missingProducts
    // productsNeededToMeetRequirement: missingProducts.map(product => product.name).join(", "),
  };
}
function testCartMeetsPriceThreshold(threshold, cartTotalPrice = 0) {
  let centsNeededToReachThreshold = parseInt(threshold) - cartTotalPrice;
  let centsNeededToReachThresholdString = centsNeededToReachThreshold.toString();
  let dollarsNeededToReachThresholdString = centsNeededToReachThresholdString.slice(0, -2) + "." + centsNeededToReachThresholdString.slice(-2);
  if (centsNeededToReachThreshold > 0) {
    return {
      doesMeetThreshold: false,
      dollarsNeededToReachThresholdString
    };
  } else {
    return { doesMeetThreshold: true, dollarsNeededToReachThresholdString };
  }
}
async function handleGwpWithCode() {
  try {
    let { cartTotalPrice, cartItemVariantIds } = await getCartData();
    const muradGwpCodeThemeData = getLocalStorage("muradGwpCodeThemeData");
    const muradGwpUserInputCodes = getLocalStorage("muradGwpUserInputCodes");
    let productsToAdd = [], productsToRemove = [];
    if (muradGwpCodeThemeData && Array.isArray(muradGwpCodeThemeData) && muradGwpUserInputCodes && Array.isArray(muradGwpUserInputCodes)) {
      for (let themeGwpCode of muradGwpCodeThemeData) {
        let codeAddedForItem = muradGwpUserInputCodes.find(
          (codeVal) => codeVal.codeHash === themeGwpCode.codeHash && (codeVal.status === "validApplied" || codeVal.status === "validMissingProducts" || codeVal.status === "validBelowThreshold")
        );
        let {
          doesMeetProductPurchaseRequirement,
          productsNeededToMeetRequirement
        } = testCartMeetsProductPurchaseRequirement(
          themeGwpCode.requiredProductPurchases,
          cartItemVariantIds
        );
        let { doesMeetThreshold, dollarsNeededToReachThresholdString } = testCartMeetsPriceThreshold(themeGwpCode.threshold, cartTotalPrice);
        if (codeAddedForItem && doesMeetProductPurchaseRequirement && doesMeetThreshold) {
          productsToAdd.push({ ...themeGwpCode, ...codeAddedForItem });
        } else {
          productsToRemove.push(themeGwpCode);
        }
      }
    } else {
    }
    const formatForVarfajAdd = (item) => ({
      id: item.variantId,
      quantity: 1,
      properties: {
        // Note, in case in future you use Shopify Discounts to make a paid item free: under current implementation, "_gwp:true" will prevent users from removing item (by modifying UI), even if GWP code is removed and item now has a cost;
        _gwp: true,
        _gwp_code_value: item.codeValue,
        _gwp_code_hash: item.codeHash,
        // "Size" part of Varfaj's original GWP implementation; unclear why;
        Size: item.size
      }
    });
    return {
      productsToAdd: productsToAdd.map(formatForVarfajAdd),
      productsToRemove: productsToRemove.reduce((prev, curr) => {
        return {
          ...prev,
          [curr.variantId]: 0
        };
      }, {})
    };
  } catch (err) {
    throw err;
  }
}

// src/js/helpers/utils.js
async function handleGWP(type) {
  try {
    let status = 0;
    let cartRes = await fetch(`/?sections=${type}`);
    status = cartRes.status;
    let cartJson = await cartRes.json();
    let div = document.createElement("div");
    div.innerHTML = cartJson[type];
    const gwp = div.querySelector("#gwp")?.value;
    const gwpJson = gwp ? JSON.parse(gwp) : {};
    const gwpWithCodeData = await handleGwpWithCode();
    let itemsToAdd = [];
    if (gwpJson.items_to_add?.length) {
      itemsToAdd = gwpJson.items_to_add.map((item) => ({
        id: Object.keys(item)[0],
        quantity: 1,
        properties: {
          _gwp: true,
          Size: Object.values(item)[0]
        }
      }));
    }
    itemsToAdd = [...itemsToAdd, ...gwpWithCodeData?.productsToAdd];
    if (itemsToAdd.length > 0) {
      const formData = JSON.stringify({ items: itemsToAdd, sections: type });
      cartRes = await fetch("/cart/add.js", {
        headers: {
          "Content-Type": "application/json"
        },
        method: "POST",
        body: formData
      });
      status = cartRes.status;
      cartJson = await cartRes.json();
      div = document.createElement("div");
      div.innerHTML = cartJson.sections[type];
    }
    let updates = {};
    if (gwpJson.items_to_remove?.length) {
      gwpJson.items_to_remove.forEach((item, i) => {
        const threshold = Object.keys(item)[0];
        const id = Object.values(item)[0];
        if (gwpJson.type === "stack" && gwpJson.cart_total < parseInt(threshold)) {
          updates[id] = 0;
        } else if (gwpJson.type === "replace") {
          if (gwpJson.cart_total < parseInt(threshold)) {
            updates[id] = 0;
          } else if (gwpJson.items_to_remove.length === 1 && gwpJson.items_to_add.length && i === 0) {
            updates[id] = 0;
          } else if (i !== gwpJson.items_to_remove.length - 1) {
            updates[id] = 0;
          }
        }
      });
    }
    updates = { ...updates, ...gwpWithCodeData?.productsToRemove };
    if (Object.keys(updates).length > 0) {
      await fetch(`/cart/update.js`, {
        headers: {
          "Content-Type": "application/json"
        },
        method: "POST",
        body: JSON.stringify({ updates })
      });
      cartRes = await fetch(`/?sections=${type}`);
      status = cartRes.status;
      cartJson = await cartRes.json();
      div = document.createElement("div");
      div.innerHTML = cartJson[type];
    }
    if (status === 200) {
      if (type === "cart-page") {
        window.scrollTo(0, 0);
        window.location.reload();
        return;
      }
      const cartContent = div.querySelector("[data-ajax-cart-content]");
      const cartEl = document.querySelector(
        "[data-ajax-cart] [data-ajax-cart-content]"
      ).parentNode;
      cartEl.innerHTML = "";
      cartEl.appendChild(cartContent);
      const subtotal = div.querySelector("#subtotal").value;
      const itemCount = div.querySelector("#item_count").value;
      const hasMin = div.querySelector("#has_min").value;
      const productHandles = div.querySelector("#product_handles").value;
      document.dispatchEvent(
        new CustomEvent("ajaxcart refresh", {
          detail: {
            subtotal,
            itemCount,
            hasMin,
            productHandles,
            gwp
          }
        })
      );
    }
    return status;
  } catch (err) {
    console.error(err);
  }
}
async function addToCart(data, type = "application/x-www-form-urlencoded") {
  const cartType = window.location.href.includes("/cart") ? "cart-page" : "ajaxcart";
  try {
    const res = await fetch("/cart/add.js", {
      headers: {
        "Content-Type": type
      },
      method: "POST",
      body: data
    });
    if (res.status === 200)
      handleGWP(cartType);
  } catch (error) {
    console.error(error);
  }
}
function formatPrice(price) {
  return price.toLocaleString(Shopify.locale, {
    style: "currency",
    currency: Shopify.currency.active
    // if want to hide trailing zeros
    // minimumFractionDigits: Math.ceil(price % 1) * 2
  });
}
async function updateQuickAddForms(max) {
  const quickAddForms = document.querySelectorAll('[data-is-quick-add="true"]');
  const cart = await fetch("/cart.js");
  const json = await cart.json();
  quickAddForms.forEach((form) => {
    const id = parseInt(form.querySelector('input[name="id"]').value);
    const itemInCart = json.items.find((item) => item.id === id);
    const searchQuickAdd = form.querySelector("[data-search-quick-add]");
    const submitBtn = form.querySelector('button[type="submit"]');
    if (itemInCart) {
      if (submitBtn)
        submitBtn.disabled = itemInCart.quantity >= max;
      if (searchQuickAdd) {
        if (itemInCart.quantity >= max) {
          searchQuickAdd.classList.add("!hidden");
        } else {
          searchQuickAdd.classList.remove("!hidden");
        }
      }
    }
  });
}

export {
  getCartData,
  testCartMeetsProductPurchaseRequirement,
  testCartMeetsPriceThreshold,
  handleGWP,
  addToCart,
  formatPrice,
  updateQuickAddForms
};
